// Navbar.js

import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Sidebar from '../../Components/NavbarSection/Sidebar';
import { menuItems } from './MenuItems';
import logo from '../../Assets/logo/RSS logo.webp';
import './NavBar.css';

const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMediumScreen, setIsMediumScreen] = useState(false);
  const [activeSubmenuIndex, setActiveSubmenuIndex] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);

  const location = useLocation();
  const isTransparent = location.pathname === '/' && !isScrolled;

  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMediumScreen(window.innerWidth <= 991);
    };

    checkScreenSize();

    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    const checkScrollPosition = () => {
      setIsScrolled(window.scrollY > 80);
    };

    checkScrollPosition();

    window.addEventListener('scroll', checkScrollPosition, { passive: true });

    return () => {
      window.removeEventListener('scroll', checkScrollPosition);
    };
  }, []);

  const handleSubmenuOpen = (index) => {
    setActiveSubmenuIndex(index);
  };

  const handleSubmenuClose = () => {
    setActiveSubmenuIndex(null);
  };

  return (
    <>
      <Sidebar isOpen={isSidebarOpen} onCloseSidebar={handleToggleSidebar} />
      <nav className={`navbar1 ${isTransparent ? 'navbar1--transparent' : 'navbar1--solid'}`}>
      <div className="logo-container1">
        <Link to="/" className="home-link">
          <img src={logo} alt="Repay Security Services logo" className="logo-image" />
          <h2 className="company-name-title">
          Repay Security <span className="aboutUs-highlighted-text">Services Ltd</span>
            </h2>
        </Link>
      </div>
        {isMediumScreen && (
          <button
            type="button"
            className={`hamburger-menu ${isSidebarOpen ? 'active' : ''}`}
            onClick={handleToggleSidebar}
            aria-label={isSidebarOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isSidebarOpen}
            aria-controls="mobile-sidebar"
          >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </button>
        )}
        <ul className="menu1">
          {menuItems.map((menuItem, index) => (
            <li
              key={index}
              className="menu-item1"
              onMouseEnter={() => handleSubmenuOpen(index)}
              onMouseLeave={handleSubmenuClose}
            >
              <Link
                to={menuItem.url}
                className={location.pathname === menuItem.url ? 'aactive' : ''}
              >
                {menuItem.title}
              </Link>
              {menuItem.submenuItems.length > 0 && (
                <ul className={`submenu1 ${activeSubmenuIndex === index ? 'submenu-open1' : ''}`}>
                  {menuItem.submenuItems.map((submenuItem, subIndex) => (
                    <li key={subIndex} className="submenu-item1">
                      <Link
                        to={submenuItem.url}
                        className={location.pathname === submenuItem.url ? 'aactive' : ''}
                      >
                        {submenuItem.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
